import React from "react";
import { Link } from "react-router-dom";
import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { ReactElement } from "react";

interface NavigationItemProps {
  text: string;
  icon: ReactElement;
  path: string;
  selected: boolean;
}

export const NavigationItem: React.FC<NavigationItemProps> = ({
  text,
  icon,
  path,
  selected,
}) => (
  <ListItem disablePadding>
    <ListItemButton component={Link} to={path} selected={selected}>
      <ListItemIcon>{icon}</ListItemIcon>
      <ListItemText primary={text} />
    </ListItemButton>
  </ListItem>
);
